export const SITE_DETAILS = {
  businessName: "CORE Strategies Physical Therapy, PA",
  shortName: "CORE Strategies PT",
  phoneDisplay: "913-322-4000",
  phoneHref: "tel:+19133224000",
  addressLine1: "10400 W 103rd St #22",
  addressLocality: "Overland Park, KS 66214",
  contactEmail: "michelle@coreptkc.com",
  directionsUrl: "https://maps.google.com/?q=10400+W+103rd+St+%2322+Overland+Park+KS+66214",
  hoursSummary: "Monday–Friday · 7 a.m.–6 p.m.",
  legacyStatement: "Serving Overland Park since 2007",
  vitalityInquiryPath: "/vitality-inquiry",
} as const;
